// TODO: Remove before launch
// import {generateMockDataArray} from '360view/mocks';

export class ClientsService {
  constructor(API, Auth, DownloadFile, $http, $q) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.$http = $http;
    this.$q = $q;
  }

  getCurrencies() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/currencies`
    });
  }

  getCurrenciesDate(date) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/currencies?date=` + date
    });
  }

  getData(from, to, clients, teams) {
    const data = {
      from,
      to,
      clients: clients ? clients : [],
      teams: teams ? teams : []
    };
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/clientReports`,
      data: data
    });
  }

  getFilterData(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/activeClients`,
      params: {
        from: from,
        to: to
      }
    });
  }

  // case class CreateExport360Request(exportScope: ExportScope, from: YearMonth, to: YearMonth, data: ChartData,
  //                                   clientIds: List[ClientId], teamIds: List[TeamId], chartMetadata: ChartMetadata)

  getExportedData(exportScope, from, to, chartData, clientsIds, teamsIds, chartMetadata) {
    const body = {
      exportScope: exportScope,
      from: from,
      to: to,
      data: chartData,
      clientIds: clientsIds,
      teamIds: teamsIds,
      chartMetadata: chartMetadata
    };
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/exportedClientReports`,
      data: body,
      responseType: 'blob'
    });
  }

  getExportedDataMultipleSheets(from, to, clientsIds, teamsIds, sheets) {
    const body = {
      from: from,
      to: to,
      clientIds: clientsIds,
      teamIds: teamsIds,
      sheets: sheets
    };
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/exportedClientReports/all`,
      data: body,
      responseType: 'blob'
    });
  }

  getWorklogsExportedData(shareId){
    return this.$http({
      method: 'GET',
      url: `${this.API.shareUrl}/api/exportedClientReports`,
      params: {
        scope: 'WorklogsOnly',
        sharedChartId: shareId
      },
      responseType: 'blob'
    });
  }

  getShared360ManagementData() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/sharedClientCharts`,
    });
  }

  patchExpire(id, date) {
    const body = {
      expiresAt: date
    };

    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: `${this.API.root}/sharedClientCharts/` + id,
      data: body
    });
  }

  saveShare(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: `${this.API.root}/sharedClientCharts/` + id,
      data: data
    });
  }

  deleteShare(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/sharedClientCharts/` + id,
    });
  }

  expireShare(id) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: `${this.API.root}/sharedClientCharts/${id}/deactivate`,
    });
  }

  getSharedData(id, size, offset, sortBy, desc) {
    const sizeParam = size ? size : 1;
    const descendingParam = desc === undefined || desc === null ? true : desc;
    const offsetParam = offset ? offset : 0;
    const sortByParam = sortBy ? sortBy : 'StartedAt';

    return this.$http({
      method: 'GET',
      url: `${this.API.shareUrl}/api/sharedClientCharts/${id}`,
      params: {
        size: sizeParam,
        offset: offsetParam,
        descending: descendingParam,
        sortBy: sortByParam
      }
    });
  }

  shareChartData(from, to, data, clientsIds, teamsIds, allowExport, includeWorklogs, shareScope, chartType, allowedColumns, showChart, shareName) {
    const body = {
      shareName: shareName,
      shareScope: shareScope,
      version: 1,
      from: from,
      to: to,
      data: data,
      clientIds: clientsIds,
      teamIds: teamsIds,
      includeWorklogs: includeWorklogs,
      allowExport: allowExport,
      chartMetadata: {
        chartType: chartType,
        allowedColumns: allowedColumns,
      },
      showChart: showChart
    };

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/sharedClientCharts`,
      data: body
    });
  }
}
